// extracted by mini-css-extract-plugin
export default {"wrapper":"CoverImage_wrapper__J5jdk","placeholder":"CoverImage_placeholder__8Zz4V","uploadButton":"CoverImage_uploadButton__MJLuh"};